import { render, staticRenderFns } from "./WarningDialog.vue?vue&type=template&id=0704dde9&scoped=true"
import script from "./WarningDialog.vue?vue&type=script&lang=js"
export * from "./WarningDialog.vue?vue&type=script&lang=js"
import style0 from "./WarningDialog.vue?vue&type=style&index=0&id=0704dde9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704dde9",
  null
  
)

export default component.exports